import { createChargingStation, CreateChargingStation } from '@infuse/api/e-connector/charging-station';
import { useNotify } from '@infuse/cpms/ui';
import { normalizeChargingStationForApi } from '@infuse/e-connector/charging-station/domain';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useCreateChargingStation = () => {
  const queryClient = useQueryClient();
  const { notifySuccess, notifyFailure } = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  return useMutation({
    mutationFn: (chargingStation: CreateChargingStation) =>
      createChargingStation({}, normalizeChargingStationForApi(chargingStation)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['charging-stations'] });

      notifySuccess({
        title: t('e_connector.common.notify.success'),
        message: t('e_connector.chargingStations.notify.create.success')
      });
    },
    onError: (error) => {
      notifyFailure({
        title: t('e_connector.common.notify.error'),
        message: t('e_connector.chargingStations.notify.create.error', {
          reason: getAxiosErrorMessage(error, '')
        })
      });
    }
  });
};
